class SidebarManager extends HTMLElement {
  constructor() {
    super();
    this.sidebar = document.querySelector('#sidebar-right'); // Replaced getElementById with querySelector for more flexibility in selecting elements by IDs or classes. This allows future adaptability in case the element selection needs to be changed from IDs to class selectors without major code refactoring.
    this.toggleButton = document.querySelector('#toggle-sidebar');
    this.closeButton = document.querySelector('#close-sidebar');
    this.isShopifyEditor = window.Shopify && Shopify.designMode;
    this.isOpen = false;
    this.isManuallyClosing = false;
    this.overlay = null;
  }

  connectedCallback() {
    this.setupEventListeners();
    this.closeSidebar();
  }

  setupEventListeners() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.manualCloseSidebar.bind(this));
    }

    if (this.isShopifyEditor) {
      document.addEventListener('shopify:section:select', this.handleSectionSelect.bind(this));
      document.addEventListener('shopify:section:deselect', this.handleSectionDeselect.bind(this));

      if (this.sidebar) {
        this.sidebar.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }
    } else {
      document.addEventListener('click', this.handleOutsideClick.bind(this));
    }
  }

  openSidebar() {
    if (!this.isOpen && !this.isManuallyClosing && this.sidebar) {
      this.sidebar.classList.add('active');
      document.body.classList.add('sidebar-open');
      this.disableNavPointerEvents();
      this.isOpen = true;
    }
  }

  closeSidebar() {
    if (this.isOpen && this.sidebar) {
      this.sidebar.classList.remove('active');
      document.body.classList.remove('sidebar-open');
      this.enableNavPointerEvents();
      this.isOpen = false;
    }
  }

  manualCloseSidebar(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isManuallyClosing = true;
    this.closeSidebar();

    setTimeout(() => {
      this.isManuallyClosing = false;
    }, 300);
  }

  toggleSidebar(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isOpen) {
      this.closeSidebar();
    } else {
      this.openSidebar();
    }
  }

  handleSectionSelect(event) {
    if (event.target && this.sidebar && event.target.contains(this.sidebar)) {
      this.openSidebar();
    } else {
      this.closeSidebar();
    }
  }

  handleSectionDeselect() {
    this.closeSidebar();
  }

  handleOutsideClick(event) {
    if (
      this.isOpen &&
      this.sidebar &&
      !this.sidebar.contains(event.target) &&
      (!this.toggleButton || !this.toggleButton.contains(event.target))
    ) {
      this.closeSidebar();
    }
  }

  disableNavPointerEvents() {
    const nav = document.querySelector('nav');
    if (nav) {
      nav.style.pointerEvents = 'none';
    }
  }

  enableNavPointerEvents() {
    const nav = document.querySelector('nav');
    if (nav) {
      nav.style.pointerEvents = '';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/') {
    const toggleButton = document.querySelector('#toggle-sidebar');
    if (!toggleButton) return;

    const popover = toggleButton.querySelector('.popover');
    if (!popover) return;

    popover.classList.add('active');
    toggleButton.classList.add('animated');

    const hidePopoverTimeout = setTimeout(() => {
      popover.style.opacity = 0;
      setTimeout(() => {
        popover.classList.remove('active');
        popover.style.display = 'none';
        toggleButton.classList.remove('animated');
      }, 500);
    }, 5000);

    document.addEventListener('click', (event) => {
      if (!toggleButton.contains(event.target)) {
        popover.style.opacity = 0;
        setTimeout(() => {
          popover.classList.remove('active');
          popover.style.display = 'none';
        }, 500);
      }
    });
  } else {
    const toggleButton = document.querySelector('#toggle-sidebar');
    if (toggleButton) {
      const popover = toggleButton.querySelector('.popover');
      if (popover) popover.remove(); 
    }
  }
});

customElements.define('sidebar-manager', SidebarManager);